import { app } from '../../../app';

class DirectoriesResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getCompanyDirectories(companyId) {
        const url = `app/rest/v2/company/${companyId}/directories`;
        return this.$http.get(url).then(({data}) => data)
            .then((directories) => directories.map((d) => ({...d, type: 'AD'})));
    }

    createActiveDirectory(companyId, name) {
        const url = `app/rest/v2/company/${companyId}/directories`;
        const params = {name};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getSaaspassCloudDirectoryGroups(companyId) {
        const url = `app/rest/v2/company/${companyId}/directories/spcloud/groups`;
        return this.$http.get(url).then(({data}) => data);
    }

    getDirectory(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        return this.$http.get(url).then(({data}) => data);
    }

    updateActiveDirectory(companyId, directory) {
        const url = `app/rest/v2/company/${companyId}/directories/${directory.id}`;
        return this.$http.put(url, directory).then(({data}) => data);
    }

    deleteDirectory(companyId, directoryId, keepAccounts) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {keepAccounts};
        return this.$http.delete(url, {params}).then(({data}) => data);
    }

    getDirectoryGroups(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}/groups`;
        return this.$http.get(url).then(({data}) => data);
    }

    userVerification(companyId, directoryId, verificationtypes, verificationparameter, file) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const formData = new FormData();
        formData.append('file', file);
        const params = {type: 'userverification', verificationtypes, verificationparameter};
        const headers = {'Content-Type': undefined};
        return this.$http.post(url, formData, {params, headers}).then(({data}) => data);
    }

    resendVerifications(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {type: 'resendverification'};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getDirectoryConnectionDetails(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {type: 'details'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    updateActiveDirectoryActivationCode(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {action: 'updatecode'};
        return this.$http.put(url, null, {params}).then(({data}) => data);
    }

    updateOnPremisesConnectionSettings(companyId, directoryId, dto) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {action: 'setonpremconnection'};
        return this.$http.put(url, dto, {params}).then(({data}) => data);
    }

    deactivateActiveDirectoryAgent(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}`;
        const params = {action: 'deactivateagent'};
        return this.$http.put(url, null, {params}).then(({data}) => data);
    }

    getDomains(companyId, directoryId) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}/domains`;
        return this.$http.get(url).then(({data}) => data);
    }

    createDomain(companyId, directoryId, domain) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}/domains`;
        return this.$http.post(url, domain).then(({data}) => data);
    }

    editDomain(companyId, directoryId, domain) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}/domains/${domain.id}`;
        return this.$http.put(url, domain).then(({data}) => data);
    }

    deleteDomain(companyId, directoryId, domainId, keepAccounts) {
        const url = `app/rest/v2/company/${companyId}/directories/${directoryId}/domains/${domainId}`;
        const params = {keepAccounts};
        return this.$http.delete(url, {params}).then(({data}) => data);
    }
}

app.service('DirectoriesResource', DirectoriesResource);



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directories-resource.service.js